<template>
  <dialogWrap
    v-model="isShow"
    v-if="isShow"
    :width="'824px'"
    customerTitle
  >
    <div slot="title">
      <span>应收款项变更</span>
      <el-tooltip class="item" content="车辆入库后，由系统创建的应收单操作变更，车辆交接时间将不可修改" placement="right">
        <i class="el-icon-question"></i>
      </el-tooltip>
    </div>

    <el-form
      ref="addReceivable"
      :model="addData"
      :rules="rules"
      label-width="100px"
      inline
    >
      <el-col :span="12">
        <el-form-item class="alone" :label="'应收ID' + columnSeparator">
          <p>{{ row.id }}</p>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="'应收金额' + columnSeparator">
          <p v-thousand-separator="row.receivableAmount"></p>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          prop="receivableAmount"
          :label="`变更后金额${columnSeparator}`"
        >
          <el-input
            v-number:money
            v-model="addData.receivableAmount"
            clearable
            placeholder="请输入"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="'应收日期' + columnSeparator">
          <p>{{ row.receivableDate }}</p>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          :label="'变更后日期' + columnSeparator"
          prop="receivableDate"
        >
          <el-date-picker
            v-model="addData.receivableDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            :append-to-body="false"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          prop="remark"
          :label="'变更说明' + columnSeparator"
        >
          <el-input
            v-model="addData.remark"
            type="textarea"
            placeholder="请输入内容"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
      </el-col>
    </el-form>
    <template slot="footer">
      <el-button size="small" @click="cancelFn">取消</el-button>
      <el-button
       v-if="!dingTalkShow"
        :loading="loading"
        size="small"
        type="primary"
        @click="confirmData"
      >确认变更</el-button>
      <el-button
        v-else
        :loading="loading"
        size="small"
        type="primary"
        @click="confirmData"
      >提交钉钉审批</el-button>
      <!-- 钉钉审批异常弹窗 -->
      <approve-validate-dialog
        ref="approveValidateDialogRef"
        :dingTalkShow="dingTalkShow"
        :sunbmitFun="submitAddCollection"
        @reloadClick="getDingTalkBtnStatus"
        :tableData="[row.id]"
        :isSubmitOther="false"
      />
    </template>
  </dialogWrap>
</template>

<script>
import { getSubmitDingTalkShow } from '@/api/global'
import { receivableChangeReceivable } from '@/api/financeApi'
import ApproveValidateDialog from './ApproveValidateDialog'
import { numberUtils } from '@/utils/number'

export default {
  model: {
    prop: 'show',
    event: 'change',
  },
  components: {
    ApproveValidateDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    show(val) {
      this.isShow = val
      for (const key in this.addData) {
        this.addData[key] = this.row[key]
      }
    },
    isShow(val) {
      this.$emit('change', val)
      if (val) {
        this.getDingTalkBtnStatus()
      }
    },
  },
  data() {
    return {
      isShow: false,
      loading: false,
      addData: {
        receivableAmount: '',
        receivableDate: '',
        remark: '',
      },
      rules: {
        receivableAmount: [
          {
            required: true,
            validator: this.receivableAmountCheck,
            trigger: 'blur',
          },
        ],
        receivableDate: [
          {
            required: true,
            message: '变更后应收日期不能为空',
            trigger: 'blur',
          },
        ],
        remark: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
      },
      dingTalkShow: false,
    }
  },
  methods: {
    confirmData() {
      if (Number(this.addData.receivableAmount) === Number(this.row.receivableAmount)) {
        this.$message.error('变更失败，变更前后金额一致')
        return
      }
      this.$refs.addReceivable.validate((valid) => {
        if (valid) {
          if (this.dingTalkShow) {
            // 钉钉
            this.submitDdApprove()
          } else {
            // 确认
            this.confirmBtn()
          }
        }
      })
    },
    // 确认
    confirmBtn() {
      this.$refs.approveValidateDialogRef.receivableFilterReceivable()
    },
    // 提交钉钉审批
    async submitDdApprove() {
      await this.getDingTalkBtnStatus()
      this.$refs.approveValidateDialogRef.sunbmitDdApprove()
    },
    // 查询钉钉审批是否开通
    async getDingTalkBtnStatus() {
      const params = {
        bizType: 11,
      }
      const { data } = await getSubmitDingTalkShow(params)
      this.dingTalkShow = data
    },
    receivableAmountCheck(_, value, callback) {
      const Amount = numberUtils.plus(this.row.receivedAmount, this.row.receivingAmount)
      if (value === '') {
        callback(new Error('变更后金额不能为空'))
      } else if (numberUtils.lt(value, Amount)) {
        callback(new Error(`当前应收金额不可低于${Amount}元`))
      }
      callback()
    },
    cancelFn() {
      this.$refs.addReceivable.resetFields()
      this.isShow = false
    },
    submitAddCollection() {
      if (this.loading) return
      this.loading = true
      receivableChangeReceivable({
        id: this.row.id,
        ...this.addData,
        approvalAccessModeType: (this.dingTalkShow && 2) || '',
      }).then((res) => {
        const { code } = res
        if (code === 1) {
          const msg = this.dingTalkShow ? '发起审批成功' : '变更成功！'
          this.$message.success(msg)
          this.isShow = false
          this.$emit('searchHandle', false)
        }
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
}
</style>
